import { css } from "@compiled/react";

import { wacToken } from "@/libraries/design/foundations/index.ts";

import {
    SectionHeader as BaseSectionHeader,
    SectionHeaderCell
} from "../atoms/section";

export interface SectionHeaderProps {
    sectionTitle: string;
    totalColumnCount: number;
    groupId: string;
}

export const SectionHeader = (props: SectionHeaderProps) => {
    const { sectionTitle, totalColumnCount, groupId } = props;
    return (
        <BaseSectionHeader>
            <SectionHeaderCell id={groupId} colSpan={totalColumnCount}>
                <span css={sectionHeaderSpanCss}>{sectionTitle}</span>
            </SectionHeaderCell>
        </BaseSectionHeader>
    );
};

const sectionHeaderSpanCss = css({
    color: wacToken("color.primary.black"),
    width: "100%",
    fontWeight: "bold",
    height: "auto",
    display: "block",
    overflowWrap: "break-word"
});
